import { useInfiniteQuery, } from '@tanstack/react-query';
import { fetchGetApiTasks, } from '../../generated/sitComponents';
import { queryKeyFn, useSitContext } from '../../generated/sitContext';
import { createGetNextPageParam } from '../pagination';
import { CACHE_TIMES } from '../query';
export const useGetApiTasksInfinite = (variables, options) => {
    const { fetcherOptions } = useSitContext(options);
    const { pageNumber = 1, ...partialQueryParams } = variables.queryParams;
    const queryParams = {
        ...partialQueryParams,
        activeOnly: 'true',
    };
    return useInfiniteQuery({
        queryKey: queryKeyFn({
            path: '/tasks',
            operationId: 'getApiTasks',
            variables: {
                ...variables,
                queryParams,
            },
        }),
        queryFn: ({ signal, pageParam }) => fetchGetApiTasks({
            ...fetcherOptions,
            ...variables,
            queryParams: {
                ...queryParams,
                pageNumber: `${pageParam ?? pageNumber}`,
            },
        }, signal),
        ...options,
        gcTime: CACHE_TIMES.THIRTY_MINUTES,
        staleTime: CACHE_TIMES.FIVE_MINUTES,
        initialPageParam: pageNumber,
        getNextPageParam: createGetNextPageParam(variables.queryParams?.pageSize),
    });
};
//# sourceMappingURL=use-infinite-tasks.js.map